export const dataHelper = {
  version: "2026-v1",
  updated: "2025-11-26",
  description: "Compact fallback для Jane Street, Citadel, Blackstone, Evercore, Goldman Sachs, Microsoft, Google, Meta, Citigroup",
  data: {
    "Jane Street": {
      v: 1,
      s: 5250,
      d: "2025-10",
      vi: "o",
    },
    Citadel: {
      v: 1,
      s: 5250,
      d: "2025-10",
      vi: "o",
    },
    Blackstone: {
      v: 1,
      s: 5200,
      d: "2025-10",
      vi: "o",
    },
    Evercore: {
      v: 1,
      s: 4800,
      d: "2025-12",
      vi: "o",
    },
    "Goldman Sachs": {
      v: 3,
      s: 4500,
      d: "2025-12",
      vi: "g",
    },
    Microsoft: {
      v: 3,
      s: 2000,
      d: "2026-04",
      vi: "g",
    },
    Google: {
      v: 3,
      s: 2100,
      d: "2025-11",
      vi: "g",
    },
    Meta: {
      v: 3,
      s: 2200,
      d: "2025-11",
      vi: "r",
    },
    Jefferies: {
      v: 1,
      s: 4300,
      d: "2025-12",
      vi: "o",
    },
    "Bank of America": {
      v: 3,
      s: 4400,
      d: "2025-12",
      vi: "g",
    },
    Citigroup: {
      v: 3,
      s: 4300,
      d: "2025-12",
      vi: "g",
    },
    Barclays: {
      v: 3, // Yes (полная виза поддержка в US & UK)
      s: 4200, // Минимальная недельная ставка ~$4200 (base + housing stipend)
      d: "2025-12", // Последний месяц подачи — обычно декабрь (rolling)
      vi: "g", // Visa: Yes
    },
    "Two Sigma": {
      v: 1, // Limited (US only, H-1B лотерея, CPT/OPT чаще всего)
      s: 5250, // ~$5250/неделя (очень высокий уровень, как у Jane Street)
      d: "2025-11", // Подача обычно заканчивается в ноябре (очень early)
      vi: "o", // Visa: Limited (US only)
    },
    KKR: { v: 3, s: 4500, d: "2025-12", vi: "g" },
    Point72: { v: 3, s: 4600, d: "2025-11", vi: "g" },
    Apollo: { v: 3, s: 4400, d: "2025-12", vi: "g" },
    "PJT Partners": { v: 1, s: 4200, d: "2025-12", vi: "o" },
    Mizuho: { v: 3, s: 4000, d: "2025-12", vi: "g" },
    Guggenheim: { v: 3, s: 4200, d: "2025-12", vi: "g" },
    "Hudson River Trading": { v: 1, s: 5200, d: "2025-11", vi: "o" },
    Stripe: {
      v: 3, // Yes
      s: 2500, // типичная минимальная недельная ставка для SWE Intern (~$130k/год эквивалент)
      d: "2025-11", // большинство internship-заявок закрываются осенью
      vi: "g", // Visa: Yes
    },

    Revolut: {
      v: 2, // Yes (EU/UK)
      s: 1200, // ориентировочная недельная ставка (эквивалент для Лондона)
      d: "2026-03", // набор обычно продолжается до весны
      vi: "g", // Visa: Yes (UK/EU)
    },
  },
  lookup: {
    v: {
      1: "Limited (US) • Yes (London/HK)",
      2: "Yes (EU/UK)",
      3: "Yes",
      4: "No",
    },
    vi: {
      g: "Yes",
      o: "Limited (US)",
      r: "Paused",
    },
    s: "weekly USD (минимальная ставка); max = min + 750 если не указано иначе",
    d: "примерный последний месяц подачи (rolling = до этого месяца)",
  },
  tooltip_full: {
    "Jane Street": ["Visa Support"],
    Citadel: ["Visa Support"],
    Blackstone: ["Visa Maybe"],
    Evercore: ["Visa Support"],
    "Goldman Sachs": ["Visa Support"],
    Microsoft: ["Visa Support"],
    Google: ["Visa Support"],
    Meta: ["Visa Maybe"],
    Jefferies: ["Visa Maybe"],
    "Bank of America": ["Visa Support"],
    Citigroup: ["Visa Support"],
    Barclays: ["Visa Support"],
    "Two Sigma": ["Visa Limited (US)"],
    KKR: ["Visa Support"],
    Point72: ["Visa Support"],
    Apollo: ["Visa Support"],
    "PJT Partners": ["Visa Maybe"],
    Mizuho: ["Visa Support"],
    Guggenheim: ["Visa Support"],
    "Hudson River Trading": ["Visa Limited (US)"],
    Stripe: ["Visa Support"],
    Revolut: ["Visa Support"],
  },
  disclaimer: "Salary & visa based on 2024–2025 data (Levels.fyi, USCIS, candidate reports). Confirm with recruiter.",
};
